import React, { useContext, useMemo } from 'react';
import { TableRow } from '@mui/material';
import Empty from "../Empty";
import TableContext from "./context";
import TCell from "./TCell";
var TEmpty = function TEmpty() {
  var _useContext = useContext(TableContext),
    dataSource = _useContext.dataSource,
    columns = _useContext.columns,
    size = _useContext.size,
    renderEmpty = _useContext.renderEmpty,
    loading = _useContext.loading;
  var empty = useMemo(function () {
    if (dataSource.length === 0 && !loading) {
      return /*#__PURE__*/React.createElement(TableRow, {
        className: "cx-table-empty-row"
      }, /*#__PURE__*/React.createElement(TCell, {
        colSpan: columns.length,
        className: "cx-table-empty-td",
        size: size,
        sx: {
          border: 'none'
        }
      }, renderEmpty ? renderEmpty : /*#__PURE__*/React.createElement(Empty, {
        className: "cx-table-empty",
        sx: {
          height: 200,
          color: 'text.disabled'
        }
      })));
    }
    return null;
  }, [dataSource, loading, renderEmpty]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, empty);
};
export default TEmpty;